import { promisify } from '@/utils';
import { transformContext, transformResult } from '@/utils/transform';
import { generateCode } from '@/utils/polyfillCode';
import { formatError } from '@/utils/formatError';
import { autoRedirect } from '@/utils/autoHash';
import { createUrlBuilder } from '@/utils/urlBuilder';

// @ts-ignore
if (AUTO_HASH) autoRedirect(window.injectInfo.pathConfig);

const bootstrapAppArgs: any = {
  layout: {
    // @ts-ignore
    titleBar: TITLE_BAR,
  },
  startupParams: {
    // @ts-ignore
    responsive: window.innerWidth < MAX_RESPONSIVE_SCREEN_WIDTH,
    page: location.hash.substring(1),
    // @ts-ignore
    transparentTitle: TITLE_BAR,
  },
  sandbox: {
    allowSameOrigin: true,
  },
  workerScript: 'data:application/javascript;base64,' + btoa(generateCode()),

  onBridgeCall(context) {
    const { name, option } = transformContext(context);

    if (my[name]) {
      const callback = context.callback();
      promisify(my[name])(option).then(
        (res) => {
          callback(
            transformResult(res, {
              name,
            })
          );
        },
        (error) => {
          // callback 带 error 自动，会触发 DSL 接口的 fail 回调
          callback(formatError(error, name));
        }
      );
    }
  },
}

if (window.injectInfo.pathConfig) {
  const urlBuilder = createUrlBuilder(window.injectInfo.pathConfig);
  bootstrapAppArgs.urlBuilder = urlBuilder;
  bootstrapAppArgs.page = urlBuilder.parse(new URL(location.href));
  bootstrapAppArgs.startupParams.page = urlBuilder.parse(new URL(location.href));
}


window.bootstrapApp(bootstrapAppArgs);
